export default "__VITE_ASSET__D$7xbb7i__"